module.exports = __webpack_public_path__ + "1ac9530495e4b62db74c760f03fe9985.pdf";